console.log('Script Wizybot cargado desde archivo externo');

function abrirWizybot() {
  console.log('Intentando abrir Wizybot...');
  const wizybotButton = document.querySelector('.WizybotShopifyWidget__open__button__inner');
  console.log('Botón encontrado:', wizybotButton);
  if (wizybotButton) {
    wizybotButton.click();
    console.log('Wizybot abierto!');
    setTimeout(function() {
      history.replaceState(null, null, window.location.pathname);
    }, 100);
  }
}

window.addEventListener('load', function() {
  console.log('Configurando listeners...');
  
  window.addEventListener('hashchange', function() {
    if (window.location.hash === '#wizybot') {
      setTimeout(abrirWizybot, 1000);
    }
  });
  
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href*="#wizybot"]');
    if (link) {
      console.log('Clic detectado');
      setTimeout(abrirWizybot, 1000);
    }
  });
});
